import { CREATE_DEVICE_GROUP, GET_ALL_DEVICE_GROUP, UPDATE_DEVICE_GROUP, DELETE_DEVICE_GROUP } from "./actionTypes";
import { deviceGroupsService } from "client-app-core";
import { v4 as uuidv4 } from "uuid";

export const createDeviceGroup = (parentId, setSelectedNodeForEdit) => (dispatch) => {
	// Generate a new group ID
	const newGroupId = uuidv4();

	// Create the new group object
	const newGroup = {
		id: newGroupId,
		name: "",
		parentGroupId: parentId,
		createdDate: new Date().toISOString(),
		devices: [],
		children: [],
		isGroup: true
	};

	// Set the new group as the selected node for editing

	// Dispatch the action with the updated state
	dispatch({
		type: CREATE_DEVICE_GROUP,
		payload: { newGroup }
	});

	setSelectedNodeForEdit(newGroupId);
};

export const addDeviceGroup = (deviceGroup) => (dispatch) => {
    dispatch({
        type: CREATE_DEVICE_GROUP,
        payload: { newGroup: { ...deviceGroup, isGroup: true, children: deviceGroup.children || [] } }
    });
};

export const updateDeviceGroup = (groupId, updatedGroup) => (dispatch) => {
	dispatch({
		type: UPDATE_DEVICE_GROUP,
		payload: { groupId, updatedGroup }
	});
};

export const getAllDeviceGroups = (deviceGroups) => ({
	type: GET_ALL_DEVICE_GROUP,
	payload: { deviceGroups }
});

export const deleteDeviceGroup = (groupId) => (dispatch) => {
	dispatch({ type: DELETE_DEVICE_GROUP, payload: { groupId } });
};

export const streamDeviceGroups = () => {
	return (dispatch) => {
		// Subscribe to device group changes

		deviceGroupsService.subscribeDeviceGroups((err, res) => {
			if (err) {
				console.error("Error streaming device groups:", err);
			} else {
				if (res.length > 0) {
					const initDeviceGroupBatch = [];

					res.forEach((change) => {
						if (change.type === "initial") {
							// Process initial batch of device groups
							if (Object.values(change.new_val).length > 0) {
								initDeviceGroupBatch.push(change.new_val);
							}
						} else if (change.type === "add") {
							const deviceGroup = change.new_val;
							dispatch(addDeviceGroup(deviceGroup));
						} else if (change.type === "change") {
							const deviceGroup = change.new_val;

							dispatch(updateDeviceGroup(deviceGroup.id, deviceGroup));
						} else if (change.type === "remove") {
							const deviceGroup = change.old_val;

							// Remove the device group by ID
							dispatch(deleteDeviceGroup(deviceGroup.id));
						}
					});

					if (initDeviceGroupBatch.length > 0) {
						dispatch(getAllDeviceGroups(initDeviceGroupBatch));
					}
				}
			}
		});
	};
};
